// removed by extract-text-webpack-plugin
module.exports = {"notification":"notification_1mJMo","message":"message_j9Vd2","cta":"cta_ds-sV","button":"button_jYLjx"};


//////////////////
// WEBPACK FOOTER
// ./app/components/notification/styles.scss
// module id = 483
// module chunks = 1